<common-loader class="{{ loaderClassName }}" [isLoading]="true" loaderClasses="big white"></common-loader>